const querystring = {
  name: 'querystring',
  lookup(options) {
    let found;

    if (typeof window !== 'undefined') {
      let query = window.location.search.substring(1);
      let hashArray = window.location.hash.split('?');
      if (!query && hashArray.length === 2) {
        query = hashArray.pop();
      }
      let params = query.split('&');
      for (let i = 0; i < params.length; i++) {
        let pos = params[i].indexOf('=');
        if (pos > 0) {
          let key = params[i].substring(0, pos);
          if (options.lookupQuerystring.indexOf(key) >= 0) {
            found = params[i].substring(pos + 1);
          }
        }
      }
    }

    return found;
  }
};

let cookieUtil = {
  create: function (name, value, minutes, domain, path) {
    let expires;
    if (minutes) {
      let date = new Date();
      date.setTime(date.getTime() + (minutes * 60 * 1000));
      expires = '; expires=' + date.toGMTString();
    } else expires = '';
    domain = domain ? 'domain=' + domain + ';' : '';
    document.cookie = name + '=' + value + expires + ';' + domain + 'path=' + (path || '/');
  },
  read: function (name) {
    let nameEQ = name + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },
  remove: function (name) {
    this.create(name, '', -1);
  }
};
const cookie = {
  name: 'cookie',
  cookie: cookieUtil,
  lookup(options) {
    let found;

    if (options.lookupCookie && options.lookupCookie.length && typeof document !== 'undefined') {
      let c = options.lookupCookie.reduce((names, name) => {
        names.push(cookieUtil.read(name));
        return names;
      }, []);
      if (c && c.length) found = c[0];
    }

    return found;
  },
  cacheUserLanguage(lng, options) {
    if (options.lookupCookie && options.lookupCookie.length && typeof document !== 'undefined') {
      options.lookupCookie.map((name) => {
        return cookieUtil.create(name, lng, options.cookieMinutes, options.cookieDomain, options.cookiePath);
      });
    }
  }
};

let hasLocalStorageSupport;
try {
  hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
  const testKey = 'localStorageTest';
  window.localStorage.setItem(testKey, 'localStorageTest');
  window.localStorage.removeItem(testKey);
} catch (e) {
  hasLocalStorageSupport = false;
}
const localStorage = {
  name: 'localStorage',
  lookup(options) {
    let found;

    if (options.lookupLocalStorage && hasLocalStorageSupport) {
      const lng = window.localStorage.getItem(options.lookupLocalStorage);
      if (lng) found = lng;
    }

    return found;
  },
  cacheUserLanguage(lng, options) {
    if (options.lookupLocalStorage && hasLocalStorageSupport) {
      window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
  }
};

const navigator = {
  name: 'navigator',
  lookup(options) {
    let found = [];
    let navigator = window && window.navigator;
    if (typeof navigator !== 'undefined') {
      if (navigator.languages) { // chrome only; not an array, so can't use .push.apply instead of iterating
        for (let i = 0; i < navigator.languages.length; i++) {
          found.push(navigator.languages[i]);
        }
      }
      if (navigator.userLanguage) {
        found.push(navigator.userLanguage);
      }
      if (navigator.language) {
        found.push(navigator.language);
      }
    }

    return found.length > 0 ? found : undefined;
  }
};

function getDefaults() {

  let path = (window && window.location.pathname.split('/')) || [];
  path.pop();
  path = path.join('/') + '/';

  return {
    order: ['querystring', 'cookie', 'localStorage', 'navigator'],
    lookupQuerystring: ['lang', 'language'],
    lookupCookie: ['lang', 'language'],
    lookupLocalStorage: '_LANG_',
    whitelist: ['zh', 'cn', 'zh'],
    fallbackLng: 'en',

    // cache user language
    caches: ['cookie', 'localStorage'],
    // excludeCacheFor: ['cimode'],
    // cookieMinutes: 10,
    cookieDomain: window.__baseDomain.welink.indexOf(window.__baseDomain.domain) > -1 ? `.${window.__baseDomain.domain}` : '.huawei.com',
    cookiePath: path,
  };
}

class Lang {
  constructor() {
    this.type = 'languageDetector';
    this.detectors = {};
    this.init();
  }

  init() {
    this.options = getDefaults();
    this.addDetector(cookie);
    this.addDetector(querystring);
    this.addDetector(localStorage);
    this.addDetector(navigator);
    this.lang = this.detect();
    this.cacheUserLanguage(this.lang);
  }

  addDetector(detector) {
    this.detectors[detector.name] = detector;
  }

  detect() {
    const detectionOrder = this.options.order;

    let detected = [];
    detectionOrder.forEach(detectorName => {
      if (this.detectors[detectorName]) {
        let lookup = this.detectors[detectorName].lookup(this.options);
        if (lookup && typeof lookup === 'string') lookup = [lookup];
        if (lookup) detected = detected.concat(lookup);
      }
    });

    let found;
    detected.forEach(lng => {
      if (found) return;
      let cleanedLng = lng.toLowerCase().substr(0, 2);
      if (this.options.whitelist.indexOf(cleanedLng) >= 0) found = cleanedLng;
    });

    if (!found) {
      found = this.options.fallbackLng;
    }
    ;

    return found;
  }

  cacheUserLanguage(lng) {
    this.options.caches.forEach(cacheName => {
      if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
    });
  }
}

export default new Lang();
